export const getAirportPriceWODiscount = ({ selectedRate, }) => {
    if (!selectedRate || !selectedRate.advertisedPrice?.discountsValue) {
        return {
            value: 0,
            currencyCode: '',
        };
    }
    const { discountsValue } = selectedRate.advertisedPrice;
    const actualDollars = selectedRate.advertisedPrice.value + Math.abs(discountsValue);
    return {
        value: actualDollars,
        currencyCode: selectedRate.advertisedPrice.currencyCode,
    };
};
export function getAirportPriceBreakdowns({ priceBreakdown, isCamelized = true, }) {
    let resultPriceBreakdown = [];
    priceBreakdown.forEach(item => {
        if (item.type === 'rental') {
            // Check for nested price breakdown items
            const nestedItems = isCamelized
                ? item.priceBreakdown?.items
                : item.price_breakdown?.items;
            if (nestedItems) {
                resultPriceBreakdown = [
                    ...resultPriceBreakdown,
                    ...nestedItems,
                ];
            }
            else {
                // Create subtotal item
                const shortDescriptionKey = isCamelized
                    ? 'shortDescription'
                    : 'short_description';
                const fullDescriptionKey = isCamelized
                    ? 'fullDescription'
                    : 'full_description';
                const originalShortDesc = isCamelized
                    ? item.shortDescription
                    : item.short_description;
                const updatedItem = {
                    ...item,
                    [shortDescriptionKey]: 'Subtotal',
                    [fullDescriptionKey]: originalShortDesc,
                };
                resultPriceBreakdown.push(updatedItem);
            }
        }
        else {
            resultPriceBreakdown.push(item);
        }
    });
    return resultPriceBreakdown;
}
